import Contenedor from '../../../components/common/Contenedor';
import { Menu } from './menu';

export const ModuloCatalogosRestaurante = () => {
  return (
    <Contenedor title="Catalogos del restaurante" children={<Menu />} />
  )
}
